import { clsx } from 'clsx';
import { env } from '@/env';
import { PRetailer } from '@/pages/FarmerPages/FarmersHomePage/FarmersHomePage';

const backgroundStyles = (retailerId: string) => ({
  background: `url(${env.VITE_STATIC_URL}/retailer/images/${retailerId}-banner.png)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});

interface RetailerInfoProps {
  retailer: PRetailer;
}

const RetailerInfo = (props: RetailerInfoProps) => {
  const { retailer } = props;

  if (!retailer) return null;

  return (
    <div className="rounded-10-0 overflow-hidden min-h-[20rem] grid grid-cols-1 md:grid-cols-2">
      <div
        className="w-full justify-between h-[90px] md:h-auto"
        style={backgroundStyles(retailer.id)}
      ></div>
      <div
        className={clsx(
          'w-full  text-primary-white flex items-center p-2-0',
          !retailer.colour && 'bg-primary-blue',
        )}
        style={
          retailer.colour ? { backgroundColor: retailer.colour } : undefined
        }
      >
        <div>
          <h1 className="font-bold text-2-4 mb-2-0">{retailer.name}</h1>
          <p className="text-1-4 font-rg leading-1-94">
            {retailer.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RetailerInfo;
